import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {object} props - Props.
 * @param props.children
 * @returns {JSX.Element} Component.
 */
export const StatsSectionModalButtons = ({ children }) => {
    return (
        <>
            {children && (
                <>
                    {React.Children.map(children, (child) => (
                        <>{React.cloneElement(child)}</>
                    ))}
                </>
            )}
        </>
    );
};

StatsSectionModalButtons.defaultProps = {
    name: 'StatsSectionModalButtons'
};

StatsSectionModalButtons.propTypes = {
    children: PropTypes.any.isRequired
};
